let enabled = false;
export const enableAppSwitcher = () => {
  enabled = true;
};
export const isAppSwitcherEnabled = () => {
  return enabled;
};
//# sourceMappingURL=ApplicationSwitcherStatus.js.map